/* ADD GROUPS */
export const EDIT_QUESTION = "EDIT_QUESTION"
export const EDIT_QUESTION_SUCCESS = "EDIT_QUESTION_SUCCESS"
export const EDIT_QUESTION_CLEAN = "EDIT_QUESTION_CLEAN"
export const EDIT_QUESTION_ERROR = "EDIT_QUESTION_ERROR"
